import { MenuAndFlyoutLabels } from '@owc-packages/_types/Header';
import { HeaderState, NewChainNode } from '@owc-types/Header';
import { _addToChain, _removeFromChain, _submitTrackingInfoWhenReady } from '@owc-utils/Store/Header/utils';

export const headerNameSpace = 'OWC_HEADER';
export const headerComponentUpdate = `${headerNameSpace}_UPDATE`;
export const addToHeaderTracking = `${headerNameSpace}_TRACKING_ADD`;
export const addAndSubmitTracking = `${headerNameSpace}_TRACKING_ADD_AND_SUBMIT`;
export const flyoutOpen = `${headerNameSpace}_FLYOUT_OPEN`;
export const flyoutClose = `${headerNameSpace}_FLYOUT_CLOSE`;
export const modelsFlyoutChange = `${headerNameSpace}_MODELS_FLYOUT_CHANGE`;
export const navigationLabelsUpdate = `${headerNameSpace}_NAVIGATION_LABELS_UPDATE`;

const buildingTrackingTreeForward = (state: HeaderState, payload: NewChainNode) => {
  const trackingTree = _addToChain(state.trackingTree, payload);
  return { ...state, trackingTree };
};

const openFlyoutAction = (state: HeaderState, payload: NewChainNode[]) => {
  let flyoutChain: string[] = [];

  payload.forEach(newChainNode => {
    if (newChainNode) {
      flyoutChain = _addToChain(state.flyoutChain, newChainNode);
    }
  });

  return { ...state, flyoutChain };
};

const closeFlyoutAction = (
  state: HeaderState,
  payload: { isClose: boolean; removeFromTracking: boolean },
) => {
  const flyoutChain = _removeFromChain(state.flyoutChain, payload.isClose);
  let trackingTree = state.trackingTree;

  if (payload.removeFromTracking) {
    trackingTree = _removeFromChain(state.trackingTree, payload.isClose);
  }

  return { ...state, flyoutChain, trackingTree };
};

/*
 * We purposely are not checking for undefined labels
 * so that tracking errors can be found by the analytics teams.
 *
 * e.g. : Finding "Our_cars:undefined" or "Our_cars:" shows a clear
 * issue on the second overlay
 *
 * vs
 *
 * Finding "Our_cars" which leeds me to believe that the user only clicked
 * on the first level.
 */
const buildingTrackingTreeAndSubmitting = (
  state: HeaderState,
  trackingInfo: { label: string; url: string; flyoutLevel: number },
) => {
  let newTrackingTree: string[] | undefined;

  if (state.trackingTree) {
    newTrackingTree = [...state.trackingTree];
  }

  if (state.headerElement) {
    _submitTrackingInfoWhenReady(trackingInfo, newTrackingTree, state.headerElement);
  }

  return { ...state };
};

const toggleModelsFlyoutAction = (state: HeaderState, modelsFlyoutOpen: boolean) => {
  return {
    ...state,
    modelsFlyoutOpen,
  };
};

const navigationLabelsUpdateAction = (state: HeaderState, navigationLabels: MenuAndFlyoutLabels) => {
  return {
    ...state,
    navigationLabels,
  };
};

export const actionHandlers = {
  buildingTrackingTreeForward,
  openFlyoutAction,
  closeFlyoutAction,
  buildingTrackingTreeAndSubmitting,
  toggleModelsFlyoutAction,
  navigationLabelsUpdateAction,
};
